// eslint-disable-next-line import/prefer-default-export
export const PHONE_INPUT_DEFAULT_MASK = '(555) 555-5555';
export const NOT_NUMBER_REGEXP = /\D/g;
